// extracted by mini-css-extract-plugin
export default {"main-page":"Index_main-page__yGp-2","main-page__sections":"Index_main-page__sections__DsY45"};